import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vc-footer-social-section',
  templateUrl: './footer-social-section.component.html',
  styleUrls: ['./footer-social-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterSocialSectionComponent {
  @Input()
  socials: any;
  @Input()
  home = false;

  constructor() {}
}
